import { Injectable } from '@angular/core';
import { Cookie } from '../../core';

@Injectable()
export class LeftMenuStateService {
	private _collapsed: string[] = [];
	private readonly CACHE_KEY: string = '$$left_menu_state';
	private readonly SEPARATOR: string = '#';

	constructor(private _cookie: Cookie) {
		this._load();
	}

	/// PUBLIC METHODS
	toggle(key: string, collapsed?: boolean): void {
		key = this._normalizeKey(key);

		const idx = this._collapsed.indexOf(key);

		collapsed = (collapsed == true || collapsed == false) ? collapsed : idx < 0;

		if (collapsed) {
			if (idx < 0) {
				this._collapsed.push(key);
			}
		}
		else if (idx > -1) {
			this._collapsed.splice(idx, 1);
		}
	}

	isOpen(key: string): boolean {
		return !this.isClosed(key);
	}

	isClosed(key: string): boolean {
		key = this._normalizeKey(key);

		return this._collapsed.indexOf(key) >= 0;
	}

	clear(): void {
		this._cookie.remove(this.CACHE_KEY);
	}

	/// PRIVATE METHODS
	private _normalizeKey(key: string): string {
		if (key == null || key.trim().length == 0) {
			throw 'Key can\'t be empty or null!';
		}

		return key.trim()
			.toLowerCase()
			.replace(this.SEPARATOR, '_');
	}

	private _load() {
		const value = this._cookie.get(this.CACHE_KEY);

		if (value != null) {
			this._collapsed = value.split(this.SEPARATOR);
		}
	}

	private _save() {
		this._cookie.put(this.CACHE_KEY, this._collapsed.join(this.SEPARATOR));
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/left-menu-state.service.ts